module.exports = __webpack_public_path__ + "img/campaign_background.d5be8ed7.png";